import { Component, OnInit } from '@angular/core';
import { ContenidoService } from '../../servicios/contenido.service';
import { Punto } from '../../entidades/Punto';



@Component({
  selector: 'app-cobertura',
  templateUrl: './cobertura.component.html',
  styleUrls: ['./cobertura.component.css']
})
export class CoberturaComponent implements OnInit {

	puntoCentral: Punto;
  marcadores: Punto[];
  zoom: number = this.getZoom();
  

  
  constructor(private _contenidoService: ContenidoService) {
	  this.puntoCentral = _contenidoService.getPuntoCentral();
	  this.marcadores = _contenidoService.getMarcadores();
  }

  ngOnInit() {
  }

  getZoom() {
    if (window.screen.height < 768) {
      return 8;
    }else {
      return 10;
    }
  }

}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/cobertura/cobertura.component.ts